import type { TRichTextElement } from '@shared/dream-components';
import { RichTextElement } from '@shared/dream-components';
import type { ReactNode } from 'react';
import useProductMergeTagProcessor from './hooks/useProductMergeTagProcessor';

interface Props {
  node: TRichTextElement;
  children: ReactNode | ReactNode[];
}

const RichText = ({ node, children }: Props) => {
  const { node: processedNode, children: childrenToRender } = useProductMergeTagProcessor({ node, children });

  return <RichTextElement element={processedNode as TRichTextElement}>{childrenToRender}</RichTextElement>;
};

export default RichText;
